import { PageHeader } from '@/shared/layouts/PageHeader';
import { registerAdminWidgets } from '../widgets/admin/register';
import { registerSharedWidgets } from '../widgets/shared/registerSharedWidgets';
import { adminLayout } from '../widgets/admin/adminLayout';
import { DashboardLayoutEngine } from '../infrastructure/layout/DashboardLayoutEngine';
import { DashboardProvider } from '../infrastructure/hooks/DashboardProvider';

export function AdminDashboard() {
  // Register the admin widgets when the dashboard is loaded
  registerAdminWidgets();
  registerSharedWidgets();

  return (
    <DashboardProvider>
      <div className="flex flex-col gap-6">
        <PageHeader
          title="Command Center"
          description="Real-time overview of lead generation and pipeline health."
          breadcrumbs={[
            { label: 'Home', to: '/' },
            { label: 'Admin Dashboard' },
          ]}
          actions={
            <span className="inline-flex items-center gap-1.5 rounded-full border border-outline bg-surface-variant px-3 py-1 text-label-caps uppercase text-on-surface-variant">
              <span className="h-2 w-2 rounded-full bg-success animate-pulse" />
              Active monitoring
            </span>
          }
        />

        <DashboardLayoutEngine layout={adminLayout} />
      </div>
    </DashboardProvider>
  );
}
